import { render, staticRenderFns } from "./DetailProjects.vue?vue&type=template&id=22ca98c4&lang=html"
import script from "./DetailProjects.vue?vue&type=script&lang=js"
export * from "./DetailProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports